import { render, staticRenderFns } from "./SubscriptionCardDiscount.vue?vue&type=template&id=ace39b9a&scoped=true&"
import script from "./SubscriptionCardDiscount.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCardDiscount.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionCardDiscount.vue?vue&type=style&index=0&id=ace39b9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace39b9a",
  null
  
)

export default component.exports